import axios from 'axios'

import api from 'service/api'
import * as service from 'service'
import { getBaseURL } from 'service/env'

const dponetAPI = api.create('dponet')
const baseURL = getBaseURL('dponet')

const get = async ({ integrationId = '', ...params }) => {
  return await dponetAPI.get(
    `/external_platform_integrations/${integrationId}`,
    { params },
  )
}

// Quando há um arquivo (pem_file) a enviar, o payload precisa ir como
// multipart/form-data (FormData), fora do dponetAPI (que serializa tudo como
// JSON) — mesmo padrão já usado em outros uploads do projeto (ex:
// companies.updateSelfLogo, questionControls.takeRisk).
const multipartConfig = () => ({
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: service.dponet.auth.getToken(),
  },
})

const create = async ({ data, ...rest }) => {
  if (data instanceof FormData) {
    return await axios({
      method: 'POST',
      url: `${baseURL}/external_platform_integrations`,
      data,
      ...multipartConfig(),
    })
  }

  return await dponetAPI.post('/external_platform_integrations', rest)
}

const update = async ({ integrationId = '', data, ...rest }) => {
  if (data instanceof FormData) {
    return await axios({
      method: 'PUT',
      url: `${baseURL}/external_platform_integrations/${integrationId}`,
      data,
      ...multipartConfig(),
    })
  }

  return await dponetAPI.put(
    `/external_platform_integrations/${integrationId}`,
    rest,
  )
}

const changeStatus = async ({ integrationId = '' }) => {
  return await dponetAPI.put(
    `/external_platform_integrations/${integrationId}/change_status`,
  )
}

const destroy = async ({ integrationId = '' }) => {
  return await dponetAPI.delete(
    `/external_platform_integrations/${integrationId}`,
  )
}

const testConnection = async ({ integrationId = '' }) => {
  return dponetAPI.patch(
    `/external_platform_integrations/${integrationId}/test_connection`,
  )
}

export default {
  get,
  create,
  update,
  changeStatus,
  destroy,
  testConnection,
}
